<div class="content-body">
  <div class="filter-container">
    <div class="text-center mt-3" style="color: white;">
      <h2>Solicitudes pendientes <span class="txtbienvenida-2">por revisar</span></h2>
    </div>
    <div class="container mt-5">
      <form [formGroup]="filterForm">
        <div class="row">
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="" class="form-label">Nº de solicitud</label>
              <input type="text" class="form-control" formControlName="idSolicitud">
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="" class="form-label">Fecha de recepción</label>
              <input type="date" class="form-control" formControlName="fechaRecepcion">
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-2 col-xs-4">
            <div class="mb-3">
              <label for="" class="form-label">Estado de la solicitud</label>
              <select class="form-control" formControlName="idEstadoSolicitud">
                <option [value]="null">Seleccione...</option>
                @for (estado of estados; track estado) {
                  <option [value]="estado.idEstadoSolicitudIntermediario">
                    {{ estado.nombre }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-3 col-xs-4">
            <div class="mb-3">
              <label for="" class="form-label">Departamento</label>
              <select class="form-control" formControlName="idDepartamento" (change)="getCiudades($event.target.value)">
                <option [value]="null">Seleccione una opción</option>
                @for (departamento of departamentos; track departamento) {
                  <option [value]="departamento.idDepartamento">
                    {{ departamento.nombreDepartamento }}
                  </option>
                }
              </select>
            </div>
          </div>
          <div class="col-12 col-sm-4 col-md-4 col-lg-3 col-xs-4">
            <div class="mb-3">
              <label for="" class="form-label">Ciudad</label>
              <select class="form-control" formControlName="idCiudad">
                <option [value]="null">Seleccione una opción</option>
                @for (ciudad of ciudades; track ciudad) {
                  <option [value]="ciudad.idCiudad">
                    {{ ciudad.nombreCiudad }}
                  </option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="row justify-content-md-center g-3">
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="getSolicitudes()">Filtrar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button type="submit" class="btn btn-primary hvr-shrink" style="width: 180px;" (click)="limpiarFiltro()">Limpiar</button>
          </div>
          <div class="col-12 col-md-2 container-btn">
            <button class="btn  btn-primary hvr-shrink" style="width: 180px;" routerLink="/intermediario/home">Volver</button>
          </div>
        </div>

      </form>
    </div>
  </div>
  @if (solicitudesPendientes.length>0) {
    <div class="table-container">
      <div class="container">
        <table class="table table-bordered">
          <thead id="general">
            <tr>
              <th>Nº de solicitud</th>
              <th>Fecha de recepción</th>
              <th>Nombre del solicitante</th>
              <th>Tipo y número de documento</th>
              <th>Monto solicitado</th>
              <th>Estado de la solicitud</th>
              <th>Ubicación</th>
              <th id="acciones">Acciones</th>
            </tr>
          </thead>
          <tbody id="general_body">
            @for (solicitud of solicitudesPendientes; track solicitud; let i = $index) {
              <tr>
                <td scope="row" id="id-sol"><a (click)="verDetalleSolicitud(i)" [routerLink]="['../../../solicitud/intermediario', solicitud.numeroSolicitud]">{{solicitud.numeroSolicitud}}</a></td>
                <td>{{solicitud.fechaRecepcion | date: 'dd/MM/yyyy' : 'UTC'}}</td>
                <td>{{solicitud.nombreDeSolicitante}}</td>
                <td>{{solicitud.tipoYNumeroDeDocumento}}</td>
                <td>{{solicitud.montoSolicitado | currency:'USD' : 'symbol' : '1.0-0'}}</td>
                <td>{{solicitud.estadoSolicitud}}</td>
                <td>
                  {{ !solicitud.ciudad.data[0] ? '' : solicitud.ciudad.data[0].nombreCiudad }} - {{ !solicitud.departamento.data[0] ? '' : solicitud.departamento.data[0].nombreDepartamento }}
                </td>
                <td>
                  @if (solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 2 || solicitud.idEstadoSolicitud_NeoEstadoSolicitud == 1) {
                    <div>
                      @if (i==habilitarCampos) {
                        <button type="button" class="btn-icon-style btn border-0" aria-label="btn-close" data-bs-toggle="modal" data-bs-target="#negarModal" (click)="negarSolicitud(i)">
                          <i class="fas fa-times-circle text-danger"></i>
                        </button>
                      }
                      @if (i==habilitarCampos) {
                        <button type="button" class="btn-icon-style btn border-0" (click)="verSolicitud(i)">
                          <i class="fas fa-check-circle text-success"></i>
                        </button>
                      }
                      <span class="d-inline-block" tabindex="0" data-bs-toggle="tooltip" title="Ver detalle solicitud">
                        <button type="button" class="btn-icon-style btn border-0" (click)="verDetalleSolicitud(i)">
                          <i class="fas fa-eye text-primary"></i>
                        </button>
                      </span>
                    </div>
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
        <app-pagination (event)="changePage($event)" [paginaActual]="paginaActual"
        [totalPaginas]="totalPaginas"></app-pagination>
      </div>
    </div>
  }
  @if (solicitudesPendientes.length<1) {
    <div class="row justify-content-md-center text-center mt-5">
      <div class="col-12 col-sm-12">
        <h3>No tiene solicitudes pendientes</h3>
      </div>
    </div>
  }
</div>

<!-- Modal -->
<div class="modal fade" id="negarModal" tabindex="-1" aria-labelledby="editModalLabel" aria-hidden="true"
  data-bs-backdrop="static" data-bs-keyboard="false">
  <div class="modal-dialog modal-dialog-centered" style="max-width: 600px;">
    <div class="modal-content">
      <div class="modal-header">
        <h2 class="modal-title" id="editModalLabel">¿SEGURO QUE DESEAS NEGAR LA SOLICITUD DE ESTE CLIENTE?</h2>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="cancelar()">

        </button>
      </div>
      <div class="container modal-body-monto justify-content-md-center">
        <div class="row">
          <div class="col-12 col-sm-12 me-3 ms-3">
            <p>Número de solicitud: {{solicitudNegar.idSolicitud}}</p>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 me-3 ms-3">
            <p>Motivo de la negación</p>
            <select title="Seleccione una opción" class="form-control" type="number" data-width="90%" name="tipoNegacion"
              #selectOpcionNegacion="ngModel" [(ngModel)]="solicitudNegar.id_tipo_negacion" required
              [(ngModel)]="idOpcionNegacion">
              <option value="" selected disabled>Seleccione una opción</option>
              @for (tipoNegacion of tiposNegacion; track tipoNegacion) {
                <option [(value)]="tipoNegacion.idTipoNegacion">
                {{tipoNegacion.nombre}}</option>
              }
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 me-3 ms-3">
            <div class="mb-3">
              <label for="" class="form-label">Observación*</label>
              <textarea class="form-control" name="observacionNegacion" [(ngModel)]="textNegacionObservacion" required
              #textObservacionNegacion="ngModel" rows="4" minlength="1" maxlength="3000" style="width: 90%;"></textarea>
            </div>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal" (click)="cancelar()">Cancelar</button>
        <button type="button" class="btn btn-primary" [disabled]="(selectOpcionNegacion.invalid && textNegacionObservacion.length==0)"
        (click)="confirmarNegacionSolicitud()">Negar</button>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
<ngx-spinner type="ball-scale-multiple"></ngx-spinner>
